<template>

  <header class="header">
    <div class="header--desktop">
      <div class="header-container">
        <div class="header-wrap">
          <div class="header-top">
            <div class="logo header-logo">
              <a href="https://www.elmeh.ru">
              <img src="https://www.elmeh.ru/upload/medialibrary/68e/logo.png" alt="ПАО Электромеханика" style="height:41px;"></a>
            </div>
            <div class="contacts header-contacts">
              <a href="tel:88007009802" class="contacts__tel">8 800 700 98 02</a>
              <a href="tel:+78412209000" class="contacts__tel">+7 8412 209-000</a>
              <a href="mailto:info@elmeh.ru" class="contacts__mail">info@elmeh.ru</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="header--mobile">
      <div class="header--mobile__menu">
        <div class="menu--mobile-button" @click="show = !show" key="menu">
          <img src="https://img.icons8.com/ios/24/000000/menu--v2.png"/>
        </div>
      </div>
      <div class="header--mobile__logo">
        <a href="https://www.elmeh.ru" target="_blank"><img src="https://www.elmeh.ru/upload/medialibrary/68e/logo.png" alt="ПАО Электромеханика" height="41px"></a>
      </div>
      <div class="header--mobile__contacts">
        <a href="tel:88007009802">
          <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
          width="30" height="30"
          viewBox="0 0 172 172"
          style=" fill:#000000;"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#bebebf"><path d="M121.69,102.5636c-2.32773,-1.36453 -5.18867,-1.33587 -7.50493,0.04013l-11.7304,6.98893c-2.62587,1.5652 -5.90533,1.38173 -8.31333,-0.4988c-4.1624,-3.2508 -10.86467,-8.7204 -16.69547,-14.5512c-5.8308,-5.8308 -11.3004,-12.53307 -14.5512,-16.69547c-1.88053,-2.408 -2.064,-5.68747 -0.4988,-8.31333l6.98893,-11.7304c1.38173,-2.31627 1.3932,-5.20013 0.02867,-7.52787l-17.21147,-29.40053c-1.6684,-2.84373 -4.98227,-4.24267 -8.1872,-3.4572c-3.1132,0.7568 -7.1552,2.60293 -11.39213,6.8456c-13.26693,13.26693 -20.3132,35.64413 29.57827,85.5356c49.89147,49.89147 72.26293,42.85093 85.5356,29.57827c4.2484,-4.2484 6.0888,-8.29613 6.85133,-11.41507c0.774,-3.1992 -0.602,-6.49013 -3.44,-8.1528c-7.0864,-4.1452 -22.37147,-13.09493 -29.45787,-17.24587z"></path></g></g>
        </svg>
        </a>
      </div>
    </div>
    <div class="menu--mobile" v-if="show">
      <div class="menu--mobile-close">
        <img src="https://img.icons8.com/ios/24/000000/multiply.png" @click="show = !show" key="close" />
      </div>
      <div class="menu--mobile-content">
        <div class="menu--mobile-items">
          <div class="menu--mobile-item">
            <a href="https://www.elmeh.ru/catalog/" target="_blank">Каталог продукции</a>
          </div>
          <div class="menu--mobile-item">
            <a href="https://www.elmeh.ru/company/" target="_blank">О компании</a>
          </div>
          <div class="menu--mobile-item">
            <a href="https://www.elmeh.ru/services/" target="_blank">Сервис и услуги</a>
          </div>
          <div class="menu--mobile-item">
            <a href="https://www.elmeh.ru/help/" target="_blank">Сопровождение</a>
          </div>
          <div class="menu--mobile-item">
            <a href="/">Техническая документация</a>
          </div>
          <div class="menu--mobile-item">
            <a href="https://www.elmeh.ru/company/jobs/" target="_blank">Вакансии</a>
          </div>
          <div class="menu--mobile-item">
            <a href="https://www.elmeh.ru/contacts/" target="_blank">Контакты</a>
          </div>
        </div>
        <div class="menu--mobile-contacts">
          <div class="menu--mobile-information menu--mobile-adress">
            <img src="https://img.icons8.com/ios-filled/20/000000/map-pin.png"  class="menu--mobile-icons" />
            <span>г. Пенза</span>
          </div>
          <div class="menu--mobile-information menu--mobile-phones">
            <img src="https://img.icons8.com/ios-glyphs/20/000000/phone--v1.png" class="menu--mobile-icons" />
            <div class="menu--mobile-phone">
              <a href="tel:+78412209000">+7 8412 209-000</a>
              <a href="mailto:info@elmeh.ru">info@elmeh.ru</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="menu">
      <div class="menu--desktop">
        <div class="menu-overlay"></div>
        <div class="menu-container">
          <div class="menu-wrap">
            <div class="menu-items">
              <a href="https://www.elmeh.ru/catalog/" target="_blank" class="menu-item">Каталог продукции</a>
              <a href="https://www.elmeh.ru/company/" target="_blank" class="menu-item">О компании</a>
              <a href="https://www.elmeh.ru/services/" target="_blank" class="menu-item">Сервис и услуги</a>
              <a href="https://www.elmeh.ru/help/" target="_blank" class="menu-item">Сопровождение</a>
              <a href="/" class="menu-item">Техническая документация</a>
              <a href="https://www.elmeh.ru/company/jobs/" target="_blank" class="menu-item">Вакансии</a>
              <a href="https://www.elmeh.ru/contacts/" target="_blank" class="menu-item">Контакты</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="breadcrumb">
      <div class="breadcrumb-container">
        <div class="breadcrumb-wrap">
          <div class="breadcrumb-item">
            <a href="https://www.elmeh.ru" target="_blank">Главная</a>
          </div>
          <div class="breacrumb-item breadcrumb-separator"> / </div>
          <div class="breadcrumb-item">
            <a href="/">Техническая документация</a>
          </div>
        </div>
      </div>
    </div>
  </header>
  

</template>

<script>
export default {
  name: 'Header',
  data() {
    return {
      show: false,

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass">

.header
  flex: 0 0 auto
  &--desktop
    @media screen and (max-width: 970px)
      display: none
  &--mobile
    display: flex
    align-items: center
    justify-content: space-between
    padding: 20px 20px
    box-shadow: 0 5px 10px 0 rgb(0 0 0 / 10%)
    @media screen and (min-width: 969px)
      display: none
    &__logo
      padding: 0 10px
      img
        width: 100%
        height: auto
        max-width: 312px
  &-container
    max-width: 1384px
    min-width: 320px
    margin: 0 auto
  &-wrap
    margin-left: 20px
    margin-right: 20px
  &-top  
    padding-top: 24px
    padding-bottom: 24px
    display: flex
    align-items: center
    justify-content: space-between
  &-contacts 
    .contacts__tel
      color: #404040
      font-size: 16px
      font-weight: 700
      line-height: 24px
    a
      padding-left: 16px
      padding-right: 16px
      &:last-child
        padding-right: 0
.menu
  background-color: #012786
  &--desktop
    @media screen and (max-width: 970px)
      display: none
  &--mobile
    position: absolute
    width: 100%
    height: 100%
    left: 0
    top: 0
    background-color: #fff
    z-index: 100
    &-button
      cursor: pointer
    &-close
      padding: 7px 20px
      img
        cursor: pointer
    &-item
      border-bottom: 1px solid #f1f1f1
      &:first-child
        border-top: 1px solid #f1f1f1
      &:last-child
        border-bottom: none  
      a
        display: block
        padding: 15px 20px
        color: #1d1d1d
        font-weight: 500
        font-size: 16px
        line-height: 1.5
        cursor: pointer
    &-contacts
      background-color: #f1f1f1
      padding: 15px 20px
    &-information
      padding: 15px 0
      font-weight: 500
      color: #000
      font-size: 14px
      line-height: 1.4
      padding: 15px 0
    &-phones
      display: flex
      align-items: baseline
    &-phone
      display: flex
      flex-direction: column
      a
        color: #000
        &:first-child
          font-size: 18px
          font-weight: 600
    &-icons
      margin-right: 15px
  &-container
    max-width: 1384px
    min-width: 320px
    margin: 0 auto
  &-wrap
    margin-left: 20px
    margin-right: 20px
    height: 50px
    display: flex
    justify-content: center
  &-items
    display: flex
    width: 100%
    align-items: center
    justify-content: center
  &-item
    flex-grow: 1
    text-align: center
    &:hover
      background: #0136b9
  a
    color: #fff
    height: 50px
    line-height: 50px
  &-item-icon
    display: flex
    align-items: center
    svg
      &:first-child
        margin-right: 10px
      &:last-child
        margin-left: 30px
.breadcrumb
  margin-top: 30px
  margin-bottom: 11px 
  &-container
    max-width: 1384px
    min-width: 320px
    margin: 0 auto
  &-wrap
    margin-left: 20px
    margin-right: 20px
    display: flex
  &-item
    display: block
    font-size: 12px
    a
      line-height: 1.5
      color: #9a9a9a
      text-decoration: none
      &:hover
        color: #012786
  &-separator
    margin: 0 10px

@media screen and (min-width: 970)
  .header
    &--desktop
      display: block
    &-mobile
      display: none
  .menu
    &--desktop
      display: block
@media screen and (max-width: 969)
  .header
    &--desktop
      display: none
    &-mobile
      display: block
  .menu
    &--desktop
      display: block
.contacts__mail
  &:hover
    text-decoration: underline    
</style>

